import { OnInit, Input, Component, NgZone } from "@angular/core";
import { StpConfigureService } from "../stp-configure.service";
import { MainPageService } from "../../../main-page/main-page.service";
import { ExtensionInterface } from "../../../models/viewer/ExtensionInterface.model";

@Component({
    selector: 'arms-configure',
    template: `<table [ngClass]="{'arms-table-normal': isVariantChoosen, 'arms-table-narrow': !isVariantChoosen}">
    <colgroup>
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 20%;">
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 40%;">
        <col span="1" style="width: 10%;">
    </colgroup>
    <thead>
        <tr>
            <th>Arms</th>
            <th></th>
            <th [hidden]="(extensionInterface!==null)?(!extensionInterface.isVariantChoosen):true"></th>
            <th [hidden]="(extensionInterface!==null)?(!extensionInterface.isVariantChoosen):true"></th>
            <th>
                <button class="buttonTransparent" [disabled]="(extensionInterface!==null)?extensionInterface.isVariantChoosen:false">
                    <i class="material-icons icon-button" (click)="addEmptyArm()">
                        add_circle
                    </i>
                </button>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let arm of armData; let i = index" style="cursor:pointer">
            <td>{{arm.name}}</td>
            <td>
                <ng-select [items]="dirOptions" [active]="arm.dirObj" (selected)="armDirectionChanged(arm, $event)" [disabled]="(extensionInterface!==null)?extensionInterface.isVariantChoosen:false"></ng-select>
            </td>
            <td  [hidden]="(extensionInterface!==null)?(!extensionInterface.isVariantChoosen):true">
                <div class="btn-group btn-group-toggle">
                    <label class="red-button">
                        <div class="display-flex">
                             <span style="padding-right: 5px;">Border</span><input type="checkbox" [(ngModel)]="profileData.armData[i].borderBeam" (change)="isBorderValueChanged(i)" >
                        </div>
                        
                    </label>
                </div>
            </td>
            <td [hidden]="(extensionInterface!==null)?(!extensionInterface.isVariantChoosen):true">
                <app-release-select [ReleaseArray]="releaseCodeOptions" [active]="profileData.armData[i].releaseId" (selected)="releaseCodeChanged(i, $event)" ></app-release-select>
            </td>
            <td>
                <button class="buttonTransparent" [disabled]="(extensionInterface!==null)?extensionInterface.isVariantChoosen:false">
                    <i class="material-icons icon-button" (click)="removeArm(arm)">
                        remove_circle
                    </i>
                </button>
            </td>
        </tr>
    </tbody>
</table>`,
    styles: [`.buttonTransparent{padding:0;background-color:transparent;border:none}.buttonTransparent:disabled{opacity:.2}.arms-table-normal{bottom:41px;right:18px;background-color:#fff}.arms-table-narrow{bottom:41px;right:18px;width:36%;background-color:#fff}.display-flex{display:flex;align-items:center;margin-bottom:3px!important;margin-top:3px!important}`, `table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:1px}tr:nth-child(even){background-color:#ddd}.icon-button{cursor:pointer;font-size:30px;vertical-align:middle}.icon-button .close-icon{cursor:pointer;position:absolute;right:10px}.steps{display:flex;list-style:none;align-items:center;margin:0;height:60px;padding:0;justify-content:space-between}.btnStep{color:#000;font-weight:700;font-size:14px;letter-spacing:.5px;background-color:transparent;border:0;outline:0}.btnStep:disabled{opacity:.6!important;cursor:default}.step::before{background-color:#ccc9cc;margin-left:16px;min-width:70%;height:2px}.step:nth-child(1) .btnStep::before{content:"1"}.step:nth-child(2) .btnStep::before{content:"2"}.step:nth-child(3) .btnStep::before{content:"3"}.step:nth-child(4) .btnStep::before{content:"4"}.step:nth-child(5) .btnStep::before{content:"5"}.step:nth-child(6) .btnStep::before{content:"6"}.btnStep::before{display:inline-block;width:40px;min-width:40px;height:40px;border:0;border-radius:50%;right:0;background-color:#000;margin-right:12px;text-align:center;color:#fff;line-height:40px;font-size:13px}.arms-table{bottom:41px;right:18px;height:100%;background-color:#fff}.arms-table td,.arms-table th{text-align:center}.red-button{font-family:inherit;padding:7px 14px}.currentTab::before{background-color:#d0021b!important}.display-flex{display:flex;margin-bottom:10px}`]
})

export class ArmsConfigureComponent implements OnInit {
    @Input() extensionInterface: ExtensionInterface;
    public armData = [];
    public profileData: any;
    public dirOptions = [];
    public releaseCodeOptions = [];
    public isVariantChoosen: boolean = false;

    @Input() set ExtensionInterface(value: ExtensionInterface) {
        this.extensionInterface = value;
        if (this.extensionInterface !== null) {
            this.extensionInterface.loadingCompleated.subscribe(() => {
                this.zone.run(() => {
                    this.loadVariantData();
                    this.isVariantChoosen = this.extensionInterface.isVariantChoosen;
                });
            });
        }
    }


    constructor(private stpConfigureService: StpConfigureService, private mainPageService: MainPageService, private zone: NgZone) { }

    ngOnInit(): void {
        this.mainPageService.loadAllReleases().subscribe((response) => {
            this.releaseCodeOptions = response;
        });
    }

    loadVariantData(): void {
        if (!this.extensionInterface.verifyArmDefinitionForProfileConfiguration(1)) {
            this.extensionInterface.resetConnectorCrossSectionsConfig();
            this.saveConfiguration();
        }
        this.profileData = this.extensionInterface.getConnectorCrossSectionsConfig();
    }

    showArmsConfiguration() {
        this.dirOptions = this.extensionInterface.getPossibleArmDirections();
        this.armData = this.extensionInterface.getArms();
    }

    armDirectionChanged(arm, event) {
        this.extensionInterface.changeArmDirection(arm, event.id);
        this.saveConfiguration();
        this.saveVariantConfiguration();
    }

    removeArm(arm) {
        this.extensionInterface.removeArmDefintion(arm);
        this.armData = this.extensionInterface.getArms();
        this.saveConfiguration();
        this.saveVariantConfiguration();
    }

    addEmptyArm() {
        this.extensionInterface.createEmptyArm();
        this.armData = this.extensionInterface.getArms();
    }

    saveConfiguration() {
        const data = this.extensionInterface.prepareFullConnectorConfiguration();
        this.stpConfigureService.saveConnectorConfiguration(data).subscribe((response) => {
        });
    }

    saveVariantConfiguration() {
        const data = this.extensionInterface.getConnectorCrossSectionsConfig();
        this.stpConfigureService.saveConnectorVariantConfiguration(data).subscribe((response) => {
        });
    }

    releaseCodeChanged(index, event) {
        if (this.profileData.armData[index].borderBeam) {
            const armsToChange = this.checkForSiblings(this.armData[index]);
            armsToChange.forEach(arm => { this.profileData.armData.find(x => x.armId === arm.id).releaseId = event; });
        } else {
            this.profileData.armData[index].releaseId = event;
        }
        this.saveVariantConfiguration();
    }

    isBorderValueChanged(index) {
        const state = this.profileData.armData[index].borderBeam;
        const armsToChange = this.checkForSiblings(this.armData[index]);
        this.profileData.armData.forEach(arm => { arm.borderBeam = false; });
        armsToChange.forEach(arm => { this.profileData.armData.find(x => x.armId === arm.id).borderBeam = state; });
        this.saveVariantConfiguration();
    }

    checkForSiblings(arm) {
        const arms = [];
        for (let i = 0; i < this.armData.length; i++) {
            if (this.armData[i].dirObj[0].text === arm.dirObj[0].text) {
                arms.push(this.armData[i]);
            }
        }
        return arms;
    }
}
